export const parseCreationInfo = (creationInfo: string) => {
	const match = creationInfo?.match(/size:(\d+)\*(\d+)/);
	return {
		width: parseInt(match?.[1] ?? '375'),
		height: parseInt(match?.[2] ?? '375'),
	};
};
